import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { useClickOutside } from "../../../../../../hooks/useClickOutside";
import { actions, useAppDispatch } from "../../../../../../redux";
import { FadeTransitionType } from "../../../../../../redux/common";
import { OVERLAY_Z_INDEX } from "../../../../../../utils";
import { fadeAnimation, FlexColumn } from "../../../../../Common/Styles";
import { usePostCardContext } from "../PostCardContent";

export const PostCardOptions = () => {
  const dispatch = useAppDispatch();
  const {
    postCardOptionsRef,
    showPostCardOptions,
    setShowPostCardOptions,
    setReportPostOpen,
    postId,
  } = usePostCardContext();

  useClickOutside({
    ref: postCardOptionsRef,
    setState: setShowPostCardOptions,
  });

  return (
    <Container
      $fadeTransitionType={showPostCardOptions ? "FadeIn" : "FadeOut"}
      className="post-card-options"
      ref={postCardOptionsRef}
    >
      <Components.Menu size="large" withBackground={true}>
        <Components.ListItem
          type="List Item"
          label="Save"
          onClick={() => {
            setShowPostCardOptions(false);
          }}
          iconType="Bookmark"
        />
        <Components.ListItem
          type="List Item"
          label="Copy link to post"
          onClick={() => {
            setShowPostCardOptions(false);
          }}
          iconType="Link"
        />
        <Components.ListItem type="Divider" />
        <Components.ListItem
          type="List Item"
          label="Not Interested"
          onClick={() => {
            setShowPostCardOptions(false);
          }}
          iconType="EyeOff"
        />
        <Components.ListItem
          type="List Item"
          label="Mute {user}"
          onClick={() => {
            setShowPostCardOptions(false);
          }}
          iconType="XCircle"
        />
        <Components.ListItem type="Divider" />
        <Components.ListItem
          type="List Item"
          label="Report post"
          onClick={() => {
            dispatch(actions.reportPost.setReportPostStep("why_reporting"));
            setReportPostOpen(true);
            setShowPostCardOptions(false);
          }}
          iconType="Flag"
        />
        <Components.Button
          color="Primary"
          kind="Primary"
          disabled={false}
          label="Post Analysis"
          onClick={() => {
            setShowPostCardOptions(false);
            dispatch(actions.postAnalysis.setPostAnalysisModalOpen(true));
            dispatch(actions.postAnalysis.setActivePostId(postId));
          }}
          size="Small"
          width="fill"
          iconType="Ditto"
          iconPosition="left"
        />
      </Components.Menu>
    </Container>
  );
};

const Container = styled(FlexColumn)<{
  $fadeTransitionType: FadeTransitionType;
}>`
  position: absolute;
  top: 36px;
  right: 0;
  z-index: ${OVERLAY_Z_INDEX};

  ${fadeAnimation}

  button {
    justify-content: flex-start;
    padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
      ${({ theme }) => theme.spacing["spacing-2"].value}rem
      ${({ theme }) => theme.spacing["spacing-2"].value}rem
      ${({ theme }) => theme.spacing["spacing-4"].value}rem;

    svg {
      min-width: ${({ theme }) =>
        theme.spacing["spacing-5"].value}rem !important;
      min-height: ${({ theme }) =>
        theme.spacing["spacing-5"].value}rem !important;
    }
  }
`;
